import { render, staticRenderFns } from "./SteampunkDecor.vue?vue&type=template&id=028ff693&"
import script from "./SteampunkDecor.vue?vue&type=script&lang=ts&"
export * from "./SteampunkDecor.vue?vue&type=script&lang=ts&"
import style0 from "./SteampunkDecor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports